import { useEffect, useCallback, useState } from 'react';

import { Box, Grid, Button, CircularProgress, FormControlLabel, Checkbox } from '@mui/material';
import { SelectField, TextField, DateTimePicker, MultilineField, Dialog } from 'style-guide';

import { STATUS } from 'constants/global-constants';
import { REQUEST_ACTIONS, sendRequest } from 'utils/Communicator';

import { useDispatch, useSelector } from 'react-redux';
import { getOrders } from 'reducers/order-reducers/ordersSlicer';
import { snackbarToggle } from 'reducers/snackbarSlicer';
import CustomsUISet from './CustomsUISet';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CustomsUIItems from './CustomsUIItems';
import CustomsUIMAWB from './CustomsUIMAWB';
import CustomsUIIHSCodes from './CustomsUIIHSCodes';
import CheckIcon from '@mui/icons-material/Check';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';

const CustomsUIPage = ({ loginUser, order1, setSelectedOrder }) => {
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [order, setOrder] = useState(order1);
    const [expandDocs, setExpandDocs] = useState(true);
    const [expandMawb, setExpandMawb] = useState(false);
    const [selectedDataIndex, setSelectedDataIndex] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [fileCodes, setFileCodes] = useState([]);
    const [customsUiData, setCustomsUiData1] = useState([]);
    const [showcodes, setShowcodes] = useState(false);
    const [showItems, setShowItems] = useState(false);
    const [itemData, setItemData] = useState(false);
    const [itemIndex, setItemIndex] = useState(false);

    useEffect(() => {
        sendRequest(`/api/order/${order.id}`, REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                setOrder(response);
            },
            failedCallback,
        });
    }, []);
    const statuses = [
        { id: null, name: "Reset" },
        { id: 1, name: "Files Uploaded" },
        { id: 2, name: "Completed" },
        { id: 3, name: "Reject" },
        { id: 4, name: "Approve" },
    ];

    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);
    const setCustomsUiData = (dt) => {
        var data = JSON.parse(JSON.stringify(dt));
        for (var i = 0; i < data.length; i++) {
            if (data[i].fileData)
                if (typeof data[i].fileData === 'string')
                    data[i].fileData = JSON.parse(data[i].fileData);
            if (data[i].aiData)
                if (typeof data[i].aiData === 'string')
                    data[i].aiData = JSON.parse(data[i].aiData);
            if (data[i].productData)
                if (typeof data[i].productData === 'string')
                    data[i].productData = JSON.parse(data[i].productData);
        }
        setCustomsUiData1(data);
    }
    const saveCustomsUIData = (setId) => {
        var data = null;
        for (var i = 0; i < customsUiData.length; i++) {
            if (customsUiData[i].id == setId)
                data = customsUiData[i];
        }
        if (data.fileData)
            data.fileData = JSON.stringify(data.fileData);
        if (data.aiData)
            data.aiData = JSON.stringify(data.aiData);
        if (data.productData) {
            if (typeof data.productData === 'string')
                data.productData = JSON.parse(data.productData);
            for (var i = 0; i < data.productData?.length; i++) {
                try {
                    data.productData[i].consignee = order.consignee.id;
                    data.productData[i].shipper = order.shipper.id;
                } catch (error) {
                    console.log(error)
                }
            }
            data.productData = JSON.stringify(data.productData);
        }
        data.user = loginUser.id + "";
        if (!data.verifing)
            data.verifing = false;
        sendRequest('/api/customsUI/setCustomsData', REQUEST_ACTIONS.POST, data, {
            loginUser: loginUser,
            successCallback: response => {
                if (response)
                    setCustomsUiData(response);
            },
            failedCallback,
        });
    }
    const saveCustomsUIData1 = (data) => {
        if (data.fileData)
            data.fileData = JSON.stringify(data.fileData);
        if (data.aiData)
            data.aiData = JSON.stringify(data.aiData);
        if (data.productData) {
            if (typeof data.productData === 'string')
                data.productData = JSON.parse(data.productData);
            data.productData = JSON.stringify(data.productData);
        }
        if (!data.verifing)
            data.verifing = false;
        data.user = loginUser.id + "";
        sendRequest('/api/customsUI/setCustomsData', REQUEST_ACTIONS.POST, data, {
            loginUser: loginUser,
            successCallback: response => {
                if (response)
                    setCustomsUiData(response);
            },
            failedCallback,
        });
    }
    useEffect(() => {
        // predefined user abroad data get
        setLoader(true);
        sendRequest('/api/customsUI/customsData?orderId=' + order.id + "&user=" + loginUser.id, REQUEST_ACTIONS.GET, '', {
            loginUser: loginUser,
            successCallback: response => {
                if (response)
                    setCustomsUiData(response);
                setLoader(false);
            },
            failedCallback,
        });

        sendRequest('/api/codes', REQUEST_ACTIONS.GET, '', {
            successCallback: response => setFileCodes(response),
            failedCallback,
        });
    }, []);
    const [intervalCount, setIntervalCount] = useState(0);
    useEffect(() => {
        var pageInterval = setInterval(() => {
            setIntervalCount((prev) => prev + 1);
        }, 10000);
    }, []);
    useEffect(() => {
        var verifing = false;
        var mlVerifying = false;
        for (var i = 0; i < customsUiData.length; i++) {
            if (customsUiData[i].verifing)
                verifing = true;
        }
        if (order.mlVerifying)
            mlVerifying = true;
        if (mlVerifying) {

            sendRequest('/api/order/' + order.id, REQUEST_ACTIONS.GET, '', {
                loginUser: loginUser,
                successCallback: response => {
                    setOrder(response)
                },
                failedCallback,
            });
        }
        if (verifing) {
            sendRequest('/api/customsUI/customsData?orderId=' + order.id + "&user=" + loginUser.id, REQUEST_ACTIONS.GET, '', {
                loginUser: loginUser,
                successCallback: response => {
                    if (response) {
                        var data = JSON.parse(JSON.stringify(response));
                        var data1 = JSON.parse(JSON.stringify(customsUiData));
                        var changed = false;
                        for (var i = 0; i < data.length; i++) {
                            if (data1[i].verifing != data[i].verifing) {
                                data1[i].verifing = data[i].verifing;
                                changed = true;
                                if (data[i].fileData)
                                    if (typeof data[i].fileData === 'string')
                                        data1[i].fileData = JSON.parse(data[i].fileData);
                                if (data[i].aiData)
                                    if (typeof data[i].aiData === 'string')
                                        data1[i].aiData = JSON.parse(data[i].aiData);
                                if (data[i].productData)
                                    if (typeof data[i].productData === 'string')
                                        data1[i].productData = JSON.parse(data[i].productData);
                            }
                        }
                        if (changed)
                            setCustomsUiData1(data1);
                    }
                },
                failedCallback,
            });
        }
    }, [intervalCount]);

    const exportCSV = () => {
        alert("Export CSV!");
    }
    const updateData = (data) => {
        var dt = JSON.parse(JSON.stringify(customsUiData));
        setItemData(data);
        for (var i = 0; i < dt.length; i++) {
            if (dt[i].id == data.id)
                dt[i] = data;
        }
        setCustomsUiData(dt);
        return data;
    }
    const closecodes = () => {
        setShowcodes(false);
    }
    const closeitems = () => {
        setShowItems(false);
    }
    const getDocNumber = (data) => {
        var hawbs = order.orderStage[4].archives?.find(f => f.codeId == 7 && f.sid == data.id);
        var invs = order.orderStage[4].archives?.filter(f => f.codeId == 2 && f.sid == data.id);
        var pls = order.orderStage[4].archives?.filter(f => f.codeId == 11 && f.sid == data.id);
        return (hawbs ? 1 : 0) + (invs ? invs.length : 0) + (pls ? pls.length : 0);
    }
    const getCrossErrorNumber = (data) => {
        var errs = [];
        if (data?.aiData?.cross_validation?.checks) {
            for (var i = 0; i < data?.aiData?.cross_validation?.checks.length; i++) {
                if (data?.aiData?.cross_validation?.checks[i].status != "PASS")
                    errs.push(["Cross Check", data?.aiData?.cross_validation?.checks[i].message, data?.aiData?.cross_validation?.checks[i].explanation]);
            }
        }
        return errs?.length;
    }

    const [showPrompt, setShowPrompt] = useState(false);
    const [promptTitle, setPromptTitle] = useState("");
    const [promptText, setPromptText] = useState("");
    const [promptCallback, setPromptCallback] = useState(null);
    const openShowPrompt = (title, text, callback) => {
        setPromptTitle(title);
        setPromptText(text);
        setPromptCallback(() => callback); 
        setShowPrompt(true);
    }
    const closeShowPrompt = () => {
        setShowPrompt(false);
    }

    const getLocation = (id) => {
        if (id === "1") {
            return "NL";
        }
        if (id === "2") {
            return "IL";
        }
        if (id === "3") {
            return "INT";
        }
        if (id === "4") {
            return "US";
        }
        if (id === "5") {
            return "All";
        }
        switch (id) {
            case 1:
                return "NL";
            case 2:
                return "IL";
            case 3:
                return "INT";
            case 4:
                return "US";
            case 5:
                return "All";
        }
        return "NL";
    }
    return (
        <>{loader ? <Grid container item justifyContent='center'>
            <CircularProgress style={{ marginTop: "40px" }} />
        </Grid> : <div style={{ height: "calc(100vh - 100px)", overflowY: "auto", display: "block", width: "100%" }}>
                {showPrompt && <Dialog maxWidth='100vw' open={showPrompt} onHandleCancel={closeShowPrompt} title={promptTitle}>
                    <Grid item container style={{padding: "10px", marginBottom: "10px"}}>
                        {promptText}
                    </Grid>
                    <Grid item container justifyContent="center" justifyContent="space-evenly">
                        <Button
                            variant='contained'
                            onClick={() => { closeShowPrompt(); }}>
                            Close
                        </Button>
                        <Button
                            variant='contained'
                            onClick={() => {
                                closeShowPrompt();
                                promptCallback();
                            }}>
                            OK
                        </Button>
                    </Grid>
                </Dialog>}
            {showItems && <Dialog maxWidth='100vw' open={showItems} onHandleCancel={closeitems} title={'Items'}>
                <CustomsUIItems
                    order={order}
                    loginUser={loginUser}
                    data1={itemData}
                    data1Org={JSON.parse(JSON.stringify(itemData))}
                    index={itemIndex}
                    updateData1={updateData}
                    setCustomsUiData={setCustomsUiData}
                    saveCustomsUIData={saveCustomsUIData} />
            </Dialog>}
            {showcodes && <Dialog maxWidth='100vw' open={showcodes} onHandleCancel={closecodes} title={'HS Codes Sumamry'}>
                <CustomsUIIHSCodes
                    data={itemData}
                    dataOrg={JSON.parse(JSON.stringify(itemData))}
                    index={itemIndex}
                    updateData={updateData}
                    saveCustomsUIData={saveCustomsUIData} />
            </Dialog>}
                <Grid item container flexDirection="row" flexWrap="nowrap" style={{ height: "140px" }}>
                <Grid lg={4} item container flexDirection="column" style={{ padding: "10px" }}>
                    <h1 style={{ color: "#174f7c", marginBottom: "0" }}>HAWB Documents</h1>
                    <p style={{ color: "#708191", marginTop: "0", fontSize: "12px" }}>Shipment document validation and comparison</p>
                </Grid>

                    <Grid item container lg={3} flexDirection="column" flexWrap="nowrap" justifyContent="center">
                        <Grid item container lg={12} flexDirection="column" flexWrap="nowrap" style={{ padding: "13px", background: "white", borderRadius: "9px", border: "1px solid #dce5ec", boxShadow: "0 2px 8px #1b496d0b", maxHeight: "110px" }}>
                            <p style={{ fontSize: "11px", padding: "2px", margin: "0 0 0 15px", color: "#708191" }}>Info:</p>
                            <b style={{ fontSize: "15px", color: "#174f7c", padding: "2px", margin: "0 0 0 15px" }}>Order: {order.jobNumber}</b>
                            <b title={order.consignee.companyName} style={{ fontSize: "15px", color: "#174f7c", padding: "2px", margin: "0 0 0 15px" }}>Consignee: {order.consignee.companyName.substring(0, 20)}</b>
                            <b title={order.shipper.companyName} style={{ fontSize: "15px", color: "#174f7c", padding: "2px", margin: "0 0 0 15px" }}>Shipper: {order.shipper.companyName.substring(0, 20)}</b>
                        </Grid>
                </Grid>
                {/*<Grid lg={4} item container alignItems="center" justifyContent="flex-end" flexWrap="nowrap" flexDirection="column" style={{ fontSize: "13px", color: "#174f7c"}}>
                    <b style={{ margin: "3px 0" }}>Job Number: {order.jobNumber}</b>
                    <b title={order.consignee.companyName} style={{ margin: "3px 0" }}>Consignee: {order.consignee.companyShortName ? order.consignee.companyShortName.substring(0, 20) : order.consignee.companyName.substring(0, 20)}</b>
                    <b title={order.shipper.companyName} style={{ margin: "3px 0" }}>Shipper: {order.shipper.companyShortName ? order.shipper.companyShortName.substring(0, 20) : order.shipper.companyName.substring(0, 20)}</b>
                </Grid>*/}
                <Grid lg={4} item container alignItems="flex-end" justifyContent="flex-start" flexWrap="nowrap" flexDirection="column">
                    {<Button
                        variant='contained'
                        style={{
                            border: "1px solid #0b5cab",
                            borderRadius: "5px",
                            padding: "5px 8px",
                            margin: "20px 15px 15px 0",
                            background: "linear-gradient(#1682cf, #0965ae)",
                            color: "#fff",
                            fontWeight: "700",
                            cursor: "pointer"
                        }}
                        onClick={() => { setSelectedOrder(null); }}>
                        Close
                    </Button>}
                    {/*<b style={{marginRight: "20px"}}>{customsUiData[selectedDataIndex]?.hawb ? customsUiData[selectedDataIndex]?.hawb : ""}</b>*/}
                </Grid>
            </Grid>
            <Grid item container flexDirection="column" flexWrap="nowrap">
                <Grid lg={12} item container flexDirection="row" style={{ padding: "10px", border: "1px solid ", background: "linear-gradient(#fbfdff, #f1f7fb)", padding: "13px 15px" }} onClick={() => { setExpandDocs(!expandDocs) }}>
                    <Grid lg={8} item container flexDirection="row" flexWrap="nowrap">
                        <span style={{ marginRight: "20px", fontSize: "14px", transition: ".2s", transform: `${expandDocs ? "rotate(90deg)" : "rotate(0deg)"}` }}>▶</span>
                        Document Sets <span style={{ margin: "0 10px", background: "#fff6df", color: "#a96b00" }}>{customsUiData.length} {customsUiData.length == 1 ? "Set" : "Sets"}</span>
                    </Grid>
                        <Grid lg={4} item container justifyContent="flex-end" style={{ color: "#708191", fontSize:"12px" }}>
                        Click to expand / collapse
                    </Grid>
                </Grid>
                {expandDocs && <Grid lg={12} alignItems="center" item container flexDirection="row" style={{ boxSizing: "border-box", background: "white", padding: "5px 15px" }}>
                        <Grid lg={8} item container flexDirection="row" flexWrap="nowrap">
                            {(order.customsStatus < 10 || order.customsStatus == 50) && loginUser.department == 1 && <Button
                                variant='contained'
                                style={{
                                    border: "1px solid #0b5cab",
                                    margin: "0 5px",
                                    borderRadius: "5px",
                                    padding: "5px 8px",
                                    background: "linear-gradient(#1682cf, #0965ae)",
                                    color: "#fff",
                                    fontWeight: "700",
                                    fontSize: "13px",
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    openShowPrompt("HAWB files status", "Are you sure you want to set order to ready?", function () {
                                        sendRequest('/api/order/ready/' + order.id + '/' + loginUser.id + '/' + (order.location?.code ? order.location.code : getLocation(order.locationId)), REQUEST_ACTIONS.POST, '', {
                                            loginUser: loginUser,
                                            successCallback: response => {
                                                if (response) {
                                                    setOrder(response);
                                                }
                                            },
                                            failedCallback,
                                        });
                                    });
                                    //if (confirm("Are you sure you want to set order to ready?"))
                                        
                                }}>
                                Files Ready
                            </Button>}
                            {(order.customsStatus == 10) && loginUser.department == 1 && <Button
                                variant='contained'
                                style={{
                                    border: "1px solid #0b5cab",
                                    margin: "0 5px",
                                    borderRadius: "5px",
                                    padding: "5px 8px",
                                    background: "linear-gradient(#1682cf, #0965ae)",
                                    color: "#fff",
                                    fontWeight: "700",
                                    fontSize: "13px",
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    openShowPrompt("HAWB files status", "Are you sure you want to reset order status?", function () {
                                        sendRequest('/api/order/reset/' + order.id + '/' + loginUser.id + '/' + (order.location?.code ? order.location.code : getLocation(order.locationId)), REQUEST_ACTIONS.POST, '', {
                                            loginUser: loginUser,
                                            successCallback: response => {
                                                if (response) {
                                                    setOrder(response);
                                                }
                                            },
                                            failedCallback,
                                        });
                                    });
                                }}>
                                Reset
                            </Button>}
                            {((order.customsStatus >= 10 && order.customsStatus < 30) || order.customsStatus == 50) && loginUser.department == 3 && <Button
                                variant='contained'
                                style={{
                                    border: "1px solid #0b5cab",
                                    margin: "0 5px",
                                    borderRadius: "5px",
                                    padding: "5px 8px",
                                    background: "linear-gradient(#1682cf, #0965ae)",
                                    color: "#fff",
                                    fontWeight: "700",
                                    fontSize: "13px",
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    openShowPrompt("HAWB files status", "Are you sure you want to set order to complete?", function () {
                                        sendRequest('/api/order/complete/' + order.id + '/' + loginUser.id + '/' + (order.location?.code ? order.location.code : getLocation(order.locationId)), REQUEST_ACTIONS.POST, '', {
                                            loginUser: loginUser,
                                            successCallback: response => {
                                                if (response) {
                                                    setOrder(response);
                                                }
                                            },
                                            failedCallback,
                                        });
                                    });
                                }}>
                                Complete
                            </Button>}
                            {(order.customsStatus == 30 || order.customsStatus == 50) && loginUser.department == 3 && <Button
                                variant='contained'
                                style={{
                                    border: "1px solid #0b5cab",
                                    margin: "0 5px",
                                    borderRadius: "5px",
                                    padding: "5px 8px",
                                    background: "linear-gradient(#1682cf, #0965ae)",
                                    color: "#fff",
                                    fontWeight: "700",
                                    fontSize: "13px",
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    openShowPrompt("HAWB files status", "Are you sure you want to approve order?", function () {
                                        sendRequest('/api/order/approve/' + order.id + '/' + loginUser.id + '/' + (order.location?.code ? order.location.code : getLocation(order.locationId)), REQUEST_ACTIONS.POST, '', {
                                            loginUser: loginUser,
                                            successCallback: response => {
                                                if (response) {
                                                    setOrder(response);
                                                }
                                            },
                                            failedCallback,
                                        });
                                    });
                                }}>
                                Approve
                            </Button>}
                            {order.customsStatus == 30 && loginUser.department == 3 && <Button
                                variant='contained'
                                style={{
                                    border: "1px solid #0b5cab",
                                    margin: "0 5px",
                                    borderRadius: "5px",
                                    padding: "5px 8px",
                                    background: "linear-gradient(#1682cf, #0965ae)",
                                    color: "#fff",
                                    fontWeight: "700",
                                    fontSize: "13px",
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    openShowPrompt("HAWB files status", "Are you sure you want to reject order?", function () {
                                        sendRequest('/api/order/reject/' + order.id + '/' + loginUser.id + '/' + (order.location?.code ? order.location.code : getLocation(order.locationId)), REQUEST_ACTIONS.POST, '', {
                                            loginUser: loginUser,
                                            successCallback: response => {
                                                if (response) {
                                                    setOrder(response);
                                                }
                                            },
                                            failedCallback,
                                        });
                                    });
                                }}>
                                Reject
                            </Button>}
                            {order.customsStatus == 40 && loginUser.department == 3 && <Button
                                variant='contained'
                                style={{
                                    border: "1px solid #0b5cab",
                                    margin: "0 5px",
                                    borderRadius: "5px",
                                    padding: "5px 8px",
                                    background: "linear-gradient(#1682cf, #0965ae)",
                                    color: "#fff",
                                    fontWeight: "700",
                                    fontSize: "13px",
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    openShowPrompt("HAWB files status", "Are you sure you want to reset order?", function () {
                                        sendRequest('/api/order/reset/' + order.id + '/' + loginUser.id + '/' + order.locationId, REQUEST_ACTIONS.POST, '', {
                                            loginUser: loginUser,
                                            successCallback: response => {
                                                if (response) {
                                                    setOrder(response);
                                                }
                                            },
                                            failedCallback,
                                        });
                                    });
                                }}>
                                Reset
                            </Button>}
                    </Grid>
                    <Grid lg={4} item container justifyContent="flex-end">
                        {<Button
                            variant='contained'
                            style={{
                                border: "1px solid #0b5cab",
                                borderRadius: "5px",
                                padding: "5px 8px",
                                background: "linear-gradient(#1682cf, #0965ae)",
                                color: "#fff",
                                fontWeight: "700",
                                fontSize: "13px",
                                cursor: "pointer"
                            }}
                            onClick={() => {
                                if (confirm("Are you sure you want to add another set?"))
                                    sendRequest('/api/customsUI/createCustomsData?orderId=' + order.id + "&user=" + loginUser.id, REQUEST_ACTIONS.POST, '', {
                                        loginUser: loginUser,
                                        successCallback: response => {
                                            if (response) {
                                                setCustomsUiData(response);
                                                setSelectedDataIndex(response.length - 1);
                                            }
                                        },
                                        failedCallback,
                                    });
                            }}>
                                + Add Set
                        </Button>}
                    </Grid>
                    </Grid>}
                    {expandDocs && <table style={{ color: "#203040", borderCollapse: 'collapse', fontSize: "13px" }}>
                        <thead>
                            <tr style={{ background: "#f5f9fc", borderTop: "1px solid #e8eef3", borderBottom: "1px solid #dce5ec", fontWeight: "bold" }}>
                                <th style={{ padding: "10px"}}>Set Name</th>
                                <th>HAWB / Shipment</th>
                                <th>Documents</th>
                                <th>Status</th>
                                <th>Differences</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody style={{ textAlign: "center" }}>
                            {customsUiData.map((data, index) => (
                                <>
                                    <tr style={{ background: "white", borderBottom: "1px solid #e8eef3", color: "#203040" }}>
                                        <td style={{ fontWeight: "bold", color: "#225d89" }}>
                                            <Grid item container flexDirection="row" flexWrap="nowrap" alignItems="center" justifyContent="center">
                                                {data.verifing && <CircularProgress style={{ margin: "5px", height: "20px", width: "20px" }} />}
                                                {data.setDesc}
                                            </Grid>
                                        </td>
                                        <td>{data.hawb ? data.hawb : (order.orderStage[4].departureStage[0]?.house ? order.orderStage[4].departureStage[0]?.house : "-")}</td>
                                        <td>{getDocNumber(data)}</td>
                                        <td>{data.status ? statuses.find(f => f.id == data.status)?.name : "-"}</td>
                                        <td>{getCrossErrorNumber(data)}</td>
                                        <td>
                                            <Grid item container flexWrap="nowrap" justifyContent="center" style={{ gap: "5px", padding: "10px" }}>
                                                {data.verifing ? <CircleOutlinedIcon style={{ margin: "0 5px", color: "orange" }} /> : (data.verified ? <CheckIcon style={{ margin: "0 5px", color: "green" }} /> : <CheckIcon style={{ margin: "0 5px", color: "transparent" }} />)}
                                                {/*<CircleOutlinedIcon style={{ margin: "0 5px", color: "orange" }} />
                                                <CheckIcon style={{ margin: "0 5px", color: "green" }} />*/}
                                                <Button
                                                    variant='contained'
                                                    style={{
                                                        border: "1px solid #0b5cab",
                                                        borderRadius: "5px",
                                                        padding: "5px 8px",
                                                        background: "linear-gradient(#1682cf, #0965ae)",
                                                        color: "#fff",
                                                        fontWeight: "700",
                                                        fontSize: "11px",
                                                        height: "25px",
                                                        width: "45px",
                                                        cursor: "pointer",
                                                        boxShadow: "none"
                                                    }}
                                                    onClick={() => {
                                                        if (selectedDataIndex == index) {
                                                            setSelectedDataIndex(null);
                                                            setSelectedData(null);
                                                            setExpandDocs(true);
                                                        } else {
                                                            setSelectedDataIndex(index);
                                                            setSelectedData(data);
                                                            setExpandDocs(false)
                                                        }
                                                    }}>
                                                    {selectedDataIndex == index ? "Close" : "Open"}
                                                </Button>
                                                <Button
                                                    variant='contained'
                                                    style={{
                                                        border: "1px solid #0b5cab",
                                                        borderRadius: "5px",
                                                        padding: "5px 8px",
                                                        background: "#fff",
                                                        color: "#0b5cab",
                                                        fontWeight: "700",
                                                        fontSize: "11px",
                                                        height: "25px",
                                                        width: "45px",
                                                        cursor: "pointer",
                                                        boxShadow: "none"
                                                    }}
                                                    onClick={() => {
                                                        setShowItems(true);
                                                        setItemData(data);
                                                        setItemIndex(index);
                                                    }}>
                                                    Items
                                                </Button>
                                                <Button
                                                    variant='contained'
                                                    style={{
                                                        border: "1px solid #0b5cab",
                                                        borderRadius: "5px",
                                                        padding: "5px 8px",
                                                        background: "#fff",
                                                        color: "#0b5cab",
                                                        fontWeight: "700",
                                                        fontSize: "11px",
                                                        height: "25px",
                                                        width: "75px",
                                                        cursor: "pointer",
                                                        boxShadow: "none"
                                                    }}
                                                    onClick={() => {
                                                        setShowcodes(true);
                                                        setItemData(data);
                                                        setItemIndex(index);
                                                    }}>
                                                    HS Codes
                                                </Button>
                                                <Button
                                                    variant='contained'
                                                    style={{
                                                        border: "1px solid #e2aaaa",
                                                        borderRadius: "5px",
                                                        padding: "5px 8px",
                                                        background: "#fff",
                                                        color: "#c53b3b",
                                                        fontWeight: "700",
                                                        fontSize: "11px",
                                                        height: "25px",
                                                        cursor: "pointer",
                                                        boxShadow: "none"
                                                    }}
                                                    onClick={() => {
                                                        if (confirm("Are you sure you want to delete this set?")) {
                                                            setLoader(true);
                                                            sendRequest('/api/customsUI/deleteSet?orderId=' + order.id + "&setId=" + data.id + "&user=" + loginUser.id, REQUEST_ACTIONS.POST, '', {
                                                                loginUser: loginUser,
                                                                successCallback: response => {
                                                                    if (response) {
                                                                        setCustomsUiData(response);
                                                                        setSelectedDataIndex(response.length - 1);
                                                                    }
                                                                    sendRequest(`/api/order/${order.id}`, REQUEST_ACTIONS.GET, '', {
                                                                        successCallback: response => {
                                                                            setOrder(response);
                                                                            setLoader(false);
                                                                        },
                                                                        failedCallback,
                                                                    });
                                                                },
                                                                failedCallback,
                                                            });
                                                        }
                                                    }}>
                                                    Delete
                                                </Button>
                                            </Grid>
                                        </td>
                                    </tr>
                                </>
                            ))}
                        </tbody>
                    </table>}
                    {selectedDataIndex != null && <tr>
                        <CustomsUISet
                            fileCodes={fileCodes}
                            loginUser={loginUser}
                            order={order}
                            data={customsUiData[selectedDataIndex]}
                            index={selectedDataIndex}
                            updateData={updateData}
                            saveCustomsUIData={saveCustomsUIData}
                            saveCustomsUIData1={saveCustomsUIData1}
                            setCustomsUiData={setCustomsUiData}
                            setOrder={setOrder}
                            setLoader={setLoader}
                            showItems={showItems}
                            setShowItems={setShowItems}
                            statuses={statuses}
                        />
                    </tr>}

                    <Grid lg={12} item container flexDirection="row" style={{ padding: "10px", border: "1px solid ", background: "linear-gradient(#fbfdff, #f1f7fb)", padding: "13px 15px" }} onClick={() => { setExpandMawb(!expandMawb) }}>
                        <Grid lg={8} item container flexDirection="row" flexWrap="nowrap">
                            <span style={{ marginRight: "20px", fontSize: "14px", transition: ".2s", transform: `${expandMawb ? "rotate(90deg)" : "rotate(0deg)"}` }}>▶</span>
                            MAWB {order.mlVerifying && <CircularProgress style={{ margin: "5px", height: "20px", width: "20px" }} />}
                        </Grid>
                        <Grid lg={4} item container justifyContent="flex-end" style={{ color: "#708191", fontSize: "12px" }}>
                            Click to expand / collapse
                        </Grid>
                    </Grid>
                    {expandMawb && <CustomsUIMAWB fileCodes={fileCodes} loginUser={loginUser} order={order} setOrder={setOrder} setLoader={setLoader} />}
            </Grid>
        </div>}</>
    );
}


export default CustomsUIPage;